<template>
  <section class="full-page pt-4 pt-md-8">
    <v-container>
      <Wording
        :image="require('@/assets/icon/icon-yellow-process.svg')"
        :refId="data.order"
        title="รอลูกค้าชำระเงินค้ำประกัน"
        color="black"
        showRefId
        desc="กรุณารอลูกค้าชำระเงินค้ำประกัน และตรวจสอบสถานะคำสั่งซื้ออีกครั้ง"
      />
    </v-container>

    <OrderDetail :is-staff-guarantee-payment="true" />
  </section>
</template>

<script>
import { ORDER_STATUS } from '@/config/order'

export default {
  name: 'StaffGuaranteePayment',

  components: {
    OrderDetail: () => import('@/components/bnn/OrderDetail'),
    Wording: () => import('@/components/Wording'),
  },

  provide() {
    return {
      defaultActive: null,
    }
  },

  computed: {
    data() {
      return this.$store.getters['order/orderDetail']
    },
    status() {
      return this.$store.getters['order/orderStatus']
    },
  },

  async mounted() {
    await this.fetch()
  },

  methods: {
    async fetch() {
      await this.getOrder()
      this.redirectToThankYouPage()
    },
    async getOrder() {
      const uid = this.$route.params.uid
      if (uid) {
        await this.$store.dispatch('order/getOrder', uid)
        this.$store.dispatch('order/subscribeOrderStatus', uid)

        if (this.order?.data) {
          localStorage.setItem(this.order?.data?.code, uid)
        }
      }

      this.$forceUpdate()
    },
    redirectToThankYouPage() {
      if (this.status !== ORDER_STATUS.PRE_COMPLETE) {
        this.$router.push({
          name: 'Thank',
          params: { uid: this.$route.params.uid },
        })

        return
      }

      return
    },
  },

  watch: {
    status() {
      this.redirectToThankYouPage()
    },
  },
}
</script>

<style lang="stylus" scoped></style>
